import chipStyles from "../../../styles/UI/chips.module.css";
import { getContrastTextColor } from "../../../utils/colorUtil";

const TextChip = ({
  text,
  bgColor,
  classes,
}: {
  text: string;
  bgColor?: string;
  classes?: string;
}) => {
  const backgroundColor = bgColor || "var(--col-interaction-tertiary)";

  return (
    <div
      className={`${chipStyles.textChip} ${classes || ""}`}
      style={{
        backgroundColor,
        color: bgColor ? getContrastTextColor(bgColor) : undefined,
      }}
    >
      {text}
    </div>
  );
};

export default TextChip;
